import createAuthString from './createAuthString';

export default (basicAuth: string): boolean =>
  basicAuth !== '' && basicAuth !== createAuthString('', '');
